import { render, staticRenderFns } from "./NewSendSmsAction.vue?vue&type=template&id=ef08f994&scoped=true&"
import script from "./NewSendSmsAction.vue?vue&type=script&lang=js&"
export * from "./NewSendSmsAction.vue?vue&type=script&lang=js&"
import style0 from "./NewSendSmsAction.vue?vue&type=style&index=0&id=ef08f994&prod&lang=scss&scoped=true&"
import style1 from "./NewSendSmsAction.vue?vue&type=style&index=1&id=ef08f994&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef08f994",
  null
  
)

export default component.exports